import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Mint from 'mint-ui'
import axios from 'axios'
import vSelect from 'vue-select'
import 'mint-ui/lib/style.css'
import './router/http'
import VideoPlayer from 'vue-video-player'
import './common/css/style.less'

Vue.use(VideoPlayer)
Vue.use(Mint)

Vue.component('v-select', vSelect)

// Vue.use(vSelect)
Vue.prototype.Axios = axios
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
